import schemas from 'components/forms/fields/definedSchemas';
import {Text} from '../fields';

const fields = {
    user_document_post_response: {
        component: 'ImageSelect',
        label: 'Upload Images',
        name: 'user_document_post_response',
        section: 'Add Images',
    },
    document_signed_user: {
        ...schemas.boolRequiredTrue,
        label: 'Is the top of Section III: Signature and Verification signed by you?',
        section: 'Signature',
        validation: schemas.boolRequiredTrue.validation.messages({
            'any.invalid':
                'Both parts of signature Section III: Signature and Verification must be completed',
        }),
    },
    document_signed: {
        ...schemas.boolRequiredTrue,
        label: 'Is the bottom of Section III: Signature and Verification complete and signed by the person attesting to this experience?',
        section: 'Signature',
        validation: schemas.boolRequiredTrue.validation.messages({
            'any.invalid':
                'Both parts of signature Section III: Signature and Verification must be completed',
        }),
    },
    date_document_signed: {
        ...schemas.dateRequiredMaxToday,
        label: 'What date was the document signed by the person attesting to this experience?',
        section: 'Signature',
    },
    ssn_included: {
        ...schemas.boolRequiredTrue,
        label: 'Is your Reference Number or the last 4 digits of SSN included?',
        section: 'Signature',
        validation: schemas.boolRequiredTrue.validation.messages({
            'any.invalid': 'SSN or Reference number is required to proceed.',
        }),
    },
    vessel_id: {
        label: 'Vessel',
        name: 'vessel_id',
        hidden: true,
    },
    owner_operator_or_master: {
        ...schemas.boolRequired,
        label: 'Are you the Owner of the vessel?',
        section: 'Ownership',
    },
    department: {
        label: 'Did you serve in the Deck Department or the Engine Department?',
        name: 'department',
        section: 'Position Served',
    },
    deck_position_served: {
        label: 'Deck Positions',
        name: 'deck_position_served',
        section: 'Position Served',
    },
    engine_position_served: {
        label: 'Engine Positions',
        name: 'engine_position_served',
        section: 'Position Served',
    },

    total_number_days: {
        //...schemas.integerRequired,
        label: 'What is the total number of days served on this vessel?',
        section: 'Sea Service Totals',
        component: Text,
        required: true,
    },
    average_hours_underway: {
        ...schemas.integerRequiredZeroOrMore,
        label: 'Average hours underway (per day)?',
        section: 'Sea Service Totals',
        validation: schemas.integerRequiredZeroOrMore.validation.max(24).min(0),
    },
    ave_dist_offshore: {
        ...schemas.integerRequiredZeroOrMore,
        label: 'What is the average distance offshore you were underway? (miles)',
        section: 'Sea Service Totals',
    },
    days_gl: {
        ...schemas.integerRequiredZeroOrMore,
        label: 'Number of days served on Great Lakes',
        section: 'Sea Service Bodies',
    },
    days_inland: {
        ...schemas.integerRequiredZeroOrMore,
        label: 'Number of days served on waters Shoreward (Inland) of the boundary line as defined in 46 CFR Part 7',
        section: 'Sea Service Bodies',
    },
    days_nc: {
        ...schemas.integerRequiredZeroOrMore,
        label: 'Number of days served on waters Seaward (Near Coastal) of the boundary line as defined in 46 CFR Part 7',
        section: 'Sea Service Bodies',
    },
    water_body_underway: {
        ...schemas.textRequired,
        label: 'Name of the body or bodies of water upon which this vessel was underway',
        section: 'Sea Service Bodies',
    },
    year_month_days_input_json: {
        label: 'Sea Service Days',
        name: 'year_month_days_input_json',
        section: 'Sea Service',
    },
    //generate 719s fields
    applicant_name_last: {
        ...schemas.textRequired,
        label: 'Last Name',
        section: 'Name',
    },
    applicant_name_first: {
        ...schemas.textRequired,
        label: 'First Name',
        section: 'Name',
    },
    applicant_name_middle: {
        ...schemas.textOptional,
        label: 'Middle Name',
        section: 'Name',
    },
    applicant_last_4: {
        ...schemas.ssnLastFour,
        required: true,
        label: 'Last 4 Digits of Social Security Number',
        section: 'Name',
    },
    applicant_MMC: {
        ...schemas.mmcNumberRequired,
        section: 'Name',
        label: 'Your MMC number',
        required: true,
    },
    applicant_home_address_street: {
        ...schemas.textRequired,
        section: 'Address',
        label: 'Street Address',
        autocomplete: 'address-line1',
    },
    applicant_home_address_city: {
        ...schemas.textRequired,
        section: 'Address',
        label: 'City',
        autocomplete: 'address-level2',
    },
    applicant_home_address_state: {
        ...schemas.states,
        section: 'Address',
        label: 'State',
        autocomplete: 'address-level1',
    },
    applicant_home_address_zip: {
        ...schemas.textRequired,
        section: 'Address',
        label: 'Zip',
        autocomplete: 'postal-code',
    },
    applicant_phone_primary: {
        ...schemas.phoneRequired,
        section: 'Address',
        label: 'Primary Phone',
        autocomplete: 'tel',
    },
    applicant_email: {
        ...schemas.emailRequired,
        section: 'Address',
        label: 'E-mail address',
        autocomplete: 'email',
    },
};
// const generatefields = {
//     ...fields,
// }
export default fields;
